/**
 * @file    js/global.js
 *
 * copyright (c) 2006-2014 Frank Hellenkamp [jonas@depage.net]
 *
 * @author    Frank Hellenkamp [jonas@depage.net]
 */

import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import 'slick-carousel';
import './depage-jquery-plugins/depage-details';

var vvmb = (function() {
    "use strict";
    /*jslint browser: true*/
    /*global $:false */

    var baseUrl = "";
    var lang = $('html').attr('lang');
    var $main, $footer;
    var assetPath;
    var smc = new ScrollMagic.Controller();

    // local Project instance that holds all variables and public functions
    var localJS = {
        // {{{ ready
        ready: function() {
            $("html").addClass("javascript");

            baseUrl = $("head script[src*='/global.js'], head script[src*='/global.min.js'], head script[src*='/global.dev.min.js']")[0].src;
            baseUrl = baseUrl.replace(/\/js\/global(\.dev)(\.min)?\.js.*/, "");
            assetPath = baseUrl + "/js";

            localJS.setup();

            // setup global events
            $(window).on("statechangecomplete", localJS.setup);

            $main = $("main");
            $footer = $("footer");
        },
        // }}}
        // {{{ setup
        setup: function() {
            localJS.setupVarious();
            localJS.setupNavigation();
            localJS.setupScenes();
            localJS.setupSlideshow();
            localJS.setupDetails();
            localJS.setupContacts();
            localJS.setupTurnTeasers();
            localJS.setupClearCategory();
            localJS.setupInternalLinks();
        },
        // }}}
        // {{{ setupVarious
        setupVarious: function() {
            /*
            var privacyMessage = "We use cookies and similar technologies to understand how you use our services and improve your experience. By clicking 'Accept', you accept all cookies. Otherwise we use only functionally essential cookies. For more information, please see our <a href=\"{$privacyPolicyLink}\">Data Protection Policy</a>";
            if (lang == "de") {
                privacyMessage = "Um unseren Webauftritt für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Wenn Sie 'Akzeptieren' klicken, stimmen Sie der Verwendung aller Cookies zu. Andernfalls verwenden wir nur funktional unverzichtbare Cookies. Weitere Informationen, erhalten Sie in unserer <a href=\"{$privacyPolicyLink}\">Datenschutzerklärung für Webseitenbenutzer</a>.";
            }
            $("body").depageAnalytics({
                messageHtml: privacyMessage,
            });
            */

            // add click event for teaser
            $(".teaser").click( function(e) {
                if (e.isTrigger != 3) {
                    $("a", this)[0].click();
                }
            });

            try {
                $("h1, h2, h3, h1 a, h2 a, h3 a, size-M p, .size-L p, .teaser a, .downloads a, nav.toc span").hyphenate(lang);
            } catch(e) {
            }

            // enhance tel-links
            $("a[href^='tel:']").each(function() {
                var target = "call-" + this.href.replace(/[^a-z0-9]*/gi, "");
                var link = this;

                // load in iframe to supress potential errors when protocol is not available
                var $iframe = $("<iframe name=\"" + target + "\" style=\"display: none\" aria-hidden\"true\"></iframe>").appendTo("body");
                link.target = target;
            });
        },
        // }}}
        // {{{ setupNavigation
        setupNavigation: function() {
            var $navSidebar = $("div.sidebar");
            var $menus = $("div.sidebar > ul > li");

            $navSidebar.on("click", function() {
                $(this).toggleClass("active");
            });

            $("body").on("click", function(e) {
                if (!$(e.target).closest("div.sidebar").length) {
                    $navSidebar.removeClass("active");
                }
            });
        },
        // }}}
        // {{{ setupSearch
        setupSearch: function() {
            var $search = $("nav.search");
            var $searchInput = $search.find("input");

            $search.on("click", function() {
                if ($search.hasClass("active")) {
                    if ($searchInput.val() != '') {
                        $searchInput.parents("form")[0].submit();
                    }
                    $search.removeClass("active");
                } else {
                    $search.addClass("active");
                    $searchInput.focus();
                }
            });
        },
        // }}}
        // {{{ setupScenes
        setupScenes: function() {
            var smcScenes = [];
            var $newslists= $(".newslist");

            var s = new ScrollMagic.Scene({
                    offset: 100,
                })
                .addTo(smc)
                .setClassToggle("body", "scrolled");

            smcScenes.push(s);

            $(".sm-anim").each(function() {
                var el = this;
                var $el = $(this);
                var st = el.style;
                var hook = 0.7;
                var pinned = $el.hasClass("pinned");
                if ($el.is(":last-child")) {
                    hook = 0.85;
                }
                if (pinned) {
                    hook = 0;
                }

                var s = new ScrollMagic.Scene({
                        triggerElement: el,
                        triggerHook: hook
                    })
                    .addTo(smc)
                    .setClassToggle(el, "in-view");

                smcScenes.push(s);
            });
        },
        // }}}
        // {{{ setupSlideshow
        setupSlideshow: function() {
            var $slideshows = $(".slick-slideshow:not(.slick-initialized)").each( function() {
                var $slideshow = $(this);

                $slideshow.slick({
                    //slide: "div:not(.flex-spacer)",
                    dots: true,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 7000,
                    //pauseOnHover: true,
                    adaptiveHeight: false,
                    pauseOnDotsHover: true,
                    pauseOnFocus: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    //fade: true,
                });
            });
        },
        // }}}
        // {{{ setupClearCategory
        setupClearCategory: function() {
            $(".cat-item.current-cat > a").each(function() {
                var $currentCat = $(this);

                var url = $currentCat.attr("href");
                url = url.replace(/\/category\/[^\/]*\//, "/vvmb-aktuell/");
                $currentCat.attr("href", url);
            });
        },
        // }}}
        // {{{ setupInternalLinks
        setupInternalLinks: function() {
            $('a[href^="#"]').on('click', function (event) {
                event.preventDefault();

                $('html, body').animate({
                    scrollTop: $($.attr(this, 'href')).offset().top
                }, 500);
            });
        },
        // }}}
        // {{{ setupDetails
        setupDetails: function() {
            $(".details").depageDetails({
                "head": "h3, h4"
            });
        },
        // }}}
        // {{{ setupContacts
        setupContacts: function() {
            $(".has-more").on("click", ".contact", function() {
                var $contact = $(this);

                if ($contact.hasClass("active")) {
                    $contact.removeClass("active");
                } else {
                    $(".contact.active").removeClass("active");
                    $contact.addClass("active");
                }
            });

            $("body").on("click", function(e) {
                if (!$(e.target).closest(".contact").length) {
                    $(".contact.active").removeClass("active");
                }
            });
        },
        // }}}
        // {{{ setupTurnTeasers
        setupTurnTeasers: function() {
            var $teasers = $(".turn-teaser, .turn-teasers .type-milestones");

            $teasers.each(function() {
                var $teaser = $(this);

                $teaser.on("click", function() {
                    if ($teaser.hasClass("active")) {
                        $teaser.removeClass("active");
                    } else {
                        $teasers.removeClass("active");
                        $teaser.addClass("active");
                    }
                });
            });

            $("body").on("click", function(e) {
                if (!$(e.target).closest(".turn-teaser, .turn-teasers .type-milestones").length) {
                    $teasers.removeClass("active");
                }
            });
        },
        // }}}
        // {{{ setupShare
        setupShare: function() {
            if (!navigator.canShare) {
                return;
            }

            var $share = $("<a class=\"share\" title=\"Share\">Share</a>");

            let shareData = {
                title: document.title,
                text: document.title,
                url: location.href
            }

            $share.on('click', function() {
                navigator.share(shareData).then(() => {
                    console.log("shared");
                })
                .catch((e) => {
                    console.log('error: ' + e)
                });
            });

            $share.clone(true).insertAfter("footer.bottom .twitter");
            $share.clone(true).appendTo(".share-container");
        }
        // }}}
    };

    return localJS;
})();

// {{{ register ready event
$(function() {
    vvmb.ready();
});
// }}}

// vim:set ft=javascript sw=4 sts=4 fdm=marker :
